import React from "react";
import styles from "./ConvertBuy/index.module.less";
import ConvertSwapDirectionBtn from "./ConvertSwapDirectionBtn";

/** Figma input2：From/To 双卡 + 中间转换方向按钮 */
export default function ConvertInputCardsStack({ fromCard, toCard, onSwapDirection }) {
  return (
    <div className={styles["convert-buy__cards-stack"]}>
      {fromCard}
      <div className={styles["convert-buy__swap-wrap"]}>
        <ConvertSwapDirectionBtn onClick={onSwapDirection} />
      </div>
      {toCard}
    </div>
  );
}
